"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoundButton = exports.roundButtonStyle = void 0;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _Button = _interopRequireDefault(require("@cimpress/react-components/lib/Button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        && {\n          width: ", ";\n          height: ", ";\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  && {\n    width: 50px;\n    height: 50px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    padding: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var roundButtonStyle = (0, _emotion.css)(_templateObject());
exports.roundButtonStyle = roundButtonStyle;

var RoundButton = function RoundButton(_ref) {
  var className = _ref.className,
      size = _ref.size,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["className", "size", "type"]);

  return (
    /*#__PURE__*/
    _react["default"].createElement(_Button["default"], _extends({
      type: type,
      className: (0, _emotion.cx)(roundButtonStyle, (0, _emotion.css)(_templateObject2(), size ? size : '50px', size ? size : '50px'), className)
    }, rest))
  );
};

exports.RoundButton = RoundButton;